import { Auth } from '@/type';
import { Credentials } from './types';
import credentialsProvider from './delegating-credentials-provider';

export function getCredentials(platform: string, auth: Auth): Promise<Credentials|null> {
  return credentialsProvider.getCredentials(platform, auth);
}
